export const NoPage = () => <div style={{textAlign: "center"}}>
  404 page not found
</div>